// utils/formatPostTime.js

export const formatPostTime = (createdAt, mode = "relative") => {
  if (!createdAt) return "";

  const date = new Date(createdAt);

  // 🕒 Absolute time (used on Post page if you want)
  if (mode === "absolute") {
    return date.toLocaleString();
  }

  // 🧠 Relative time (Feed-style)
  const now = new Date();
  const diff = Math.floor((now - date) / 1000);

  if (diff < 60) return "Just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;

  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });
};
